// extracted by mini-css-extract-plugin
export default {"businessName":"support_businessName__Ppo5M","other":"support_other__FE6Rs","brandIcon":"support_brandIcon__7sKCN","emailRole":"support_emailRole__Bqn63"};